export const checkStyleConditions=(sel, value, jodh=null, val1 = null)=>{
    try{    
        
        let condition = false
        const styleF = sel.style[value.name].F
        const styleB = sel.style[value.name].B

        if(value.name === "Kurta"){
            
            if((value.type === "Pocket Type" && styleF[2] === "00")
                || (value.type === "Flap Type" && styleF[4] === "0")
                || (value.type === "Cuff Style" && styleF[8] === "SN")
                || (value.type.includes("Flap") && styleF[2] === "00" )
                || ( ["CR", "CB", "CT", "CS", "CE"].includes(styleF[7]) && ["NS4", "QS4"].includes(val1?.value) )
                || ( !["CR", "CB", "CT", "CS", "CE"].includes(styleF[7]) && ["NS3", "QS3"].includes(val1?.value) )
            ){
                condition = true
            } 
        }
        if(value.name === "Pajama"){

            if(value.type === "Belt" && styleF[0] === "PP"){
                condition = true;
            }
        }

        if(value.name === "Coat"){
            if(value.type === "Stitch" && val1.value === "Y" && styleF[0][0] === "J"){
                condition = true;
            }
            if((value.type === "Lapel" || value.type === "Pocket" ) && styleF[0] === "JA" ){
                condition = true;
            }
        }
        if(condition) {return condition}


        condition = (jodh && value["type"]=== "Lapel") 
        || (jodh && value["type"] === "Front Pocket" && val1?.value === "R") 
        || (value["type"] === "Front Pocket" && val1?.value === "R" && sel.style.Pant && sel.style.Pant.F[0] === "F-NP" && sel.style.Pant.F[2] === "G" )
        || (value["type"] === "Front Pocket" && val1?.value === "R" && sel.style.Pant && sel.style.Pant.F[0] === "F-SP")
        || (value["type"] === "Belt Style" && sel.style.Pant && sel.style.Pant.F[0] === "F-DP" && val1?.value === "H")
        || (value["type"] === "Belt Style" && sel.style.Pant && sel.style.Pant.F[0] === "F-NP" && val1?.value === "G" &&  sel.style.Pant.F[1] === "R")
        || ( value["type"] === "Cuffs" && sel.style.Shirt && sel.style.Shirt.F[3] === "H" )

        

        

        return condition
    } catch(e){

    }
}